<template>
  <div>
    <PageAllow controller="Shops" action="select" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="shopKeyword"
                @text="shopKeywordText($event)"
                :label="
                  $t('ShopCostMonthlyAnalyze.shopKeyword', [$consts.shopName()])
                "
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                small
                color="success"
                dark
                @click.stop="addShopCostAnalyzeDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fas fa-save</v-icon>
                {{ $t("ShopCostMonthlyAnalyze.submit") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels :value="[1]" multiple flat accordion mandatory>
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="login_user_id"
                    v-model="loginUserId"
                    @text="loginUserIdText($event)"
                    :label="$t('ShopCostMonthlyAnalyze.shopUserKeyword')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrict v-model="districtSelected" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="shopsItems"
            :loading="loading"
            multi-sort
            class="elevation-2 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.choose>
              <v-checkbox
                class="mt-2 mb-n3"
                color="primary"
                :indeterminate="
                  shopsItems.find((detail) => detail.choose != chooseAll)
                    ? true
                    : false
                "
                v-model="chooseAll"
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{ $t("CRUD.chooseAll") }}
                  </span>
                </template>
              </v-checkbox>
            </template>

            <template v-slot:item.choose="{ item }">
              <div class="d-flex mt-n2 mb-n3">
                <v-checkbox
                  color="primary"
                  v-model="item.choose"
                  :true-value="1"
                  :false-value="0"
                  :disabled="item.disabled"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                    </span>
                  </template>
                </v-checkbox>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <v-dialog v-model="addShopCostAnalyzeDialog" max-width="800px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("ShopCostAnalyze.shopCostAnalyze") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="addShopCostAnalyzeDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <v-row align="center">
            <v-col cols="3" class="font-weight-bold text-right">
              {{ $t("ShopCostAnalyze.date") + $t("Global.colon") }}
              <span class="red--text">*</span>
            </v-col>
            <v-col cols="9">
              <v-row>
                <v-col cols="5" md="4">
                  <!-- <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('MaterialOrderRule.mixProductRule.activity_time')"
                        rules="required"
                      > -->
                  <SearcherDatetime
                    class="my-n2"
                    v-model="start_date"
                    type="datetime"
                    single-line
                    dense
                    hide-details
                    hide-icon
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </SearcherDatetime>
                  <!-- </ValidationProvider> -->
                </v-col>
                <v-col cols="1" class="text-center">~</v-col>
                <v-col cols="5" md="4">
                  <!-- <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('MaterialOrderRule.mixProductRule.activity_time')"
                        rules="required"
                      > -->
                  <SearcherDatetime
                    class="my-n2"
                    v-model="end_date"
                    type="datetime"
                    single-line
                    dense
                    hide-details
                    hide-icon
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </SearcherDatetime>
                  <!-- </ValidationProvider> -->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            outlined
            @click="addShopCostAnalyzeDialog = false"
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="primary" depressed @click="submit()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import Shops from "@/api/shops";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import shopCostAnalyze from "@/api/shop_cost_analyze";

const defaultOptions = {
  keyword: "",
  login_user_id: "",
  status: [1],
  district_id: "",
  psi_expire_flg: 1, //门店开启库存管理且在有效期内
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherDistrict,
    SearcherDatetime,
  },

  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
    shopsKeyword: "",
    shops: [],
    chooseAll: 0,
    shopKeyword: "",
    loginUserId: "",
    districtSelected: null,
    districtSelectedIds: [],
    addShopCostAnalyzeDialog: false,
    start_date: null,
    end_date: null,
  }),

  computed: {
    shopsItems() {
      return this.abc();
    },
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopCostAnalyze", [this.$consts.shopName()]),
          disabled: false,
          href: "/shop-cost-analyze",
        },
        {
          text: i18n.t("ShopCostAnalyze.addShopCostAnalyze"),
          disabled: true,
          href: "",
        },
      ];
    },
    headers() {
      return [
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.shop_code", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.shop_name", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("ShopCostMonthlyAnalyze.Fields.district", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "district.name",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },
    ...mapState(["loading", "settings"]),
  },
  mounted() {
    this.getShopsFromAPI();
  },
  methods: {
    resetSearch() {
      this.districtSelected = null;
      [this.$refs.keyword, this.$refs.login_user_id].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.abc();
    },

    abc() {
      return this.shops.filter(
        (e) =>
          ((this.districtSelected &&
            this.districtSelectedIds.find((detail) => {
              return detail == e.district.id;
            })) ||
            !this.districtSelected) &&
          ((this.shopKeyword && e.shop_name.indexOf(this.shopKeyword) > -1) ||
            e.shop_code.indexOf(this.shopKeyword) > -1 ||
            !this.shopKeyword) &&
          ((this.loginUserId &&
            (e.shop_user ? e.shop_user.login_user_id : "").indexOf(
              this.loginUserId
            ) > -1) ||
            (e.shop_user ? e.shop_user.name : "").indexOf(this.loginUserId) >
              -1 ||
            !this.loginUserId)
      );
    },
    shopKeywordText(e) {
      this.shopKeyword = e;
    },
    loginUserIdText(e) {
      this.loginUserId = e;
    },

    getShopsFromAPI() {
      Shops.fetchForSelect(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            var shops = response.data.shops;
            shops.forEach((detail) => {
              detail.choose = 0;
            });
            this.shops = shops;
          }
        }.bind(this)
      );
    },

    submit() {
      let shop_ids = this.shops.filter((v) => !!v.choose).map((v) => v.id);
      shopCostAnalyze
        .addShopCostAnalyze({
          start_date: this.start_date,
          end_date: this.end_date,
          shop_ids: shop_ids,
        })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.addShopCostAnalyzeDialog = false;
              this.$router.push("/shop-cost-analyze");
            }
          }.bind(this)
        );
    },
    // 查询分组
    getdistrictSelectedIds(item, ids = []) {
      item.forEach((e) => {
        ids.push(e.id);
        if (e.districts && e.districts.length > 0) {
          this.getdistrictSelectedIds(e.districts, ids);
        }
      });
      return ids;
    },
  },

  watch: {
    chooseAll: {
      handler() {
        this.shopsItems.forEach(
          function (e) {
            e.choose = this.chooseAll ? 1 : 0;
          }.bind(this)
        );
      },
    },
    districtSelected: {
      handler() {
        var arr = [];
        arr.push(this.districtSelected);
        if (this.districtSelected) {
          this.districtSelectedIds = this.getdistrictSelectedIds(arr);
        }
      },
    },
  },
};
</script>

<style>
</style>